<template>
  <div class="oneHouse">
    <div class="header">
      <div class="title">{{'出售' +'[' + real_estate_name + '.' + build_num + '.' + unit + '.' + room_num + ']'}}</div>
      <div class="closeIcon" @click="close"></div>
    </div>
    <div class="content">
      <div class="part1">
        <div class="oneLine">
          <div>
            <div><span class="saleRent">售</span></div>
            <div>地址</div>
          </div>
          <div class="mgLeft">
            <div class="grey">楼盘</div>
            <input type="text" class="input_200" :value="real_estate_name" disabled=true>
          </div>
          <div>
            <div class="grey">幢座</div>
            <input type="text" class="input_200 border" v-model="build_num">
          </div>
          <div>
            <div class="grey">单元</div>
            <input type="text" class="input_100" v-model="unit">
          </div>
          <div>
            <div class="grey">房号</div>
            <input type="text" class="input_100 border" v-model="room_num">
          </div>
          <div>
            <div class="grey">楼层</div>
            <input type="text" class="input_100 border" v-model="floor">
          </div>
          <div>
            <div class="grey">类型</div>
            <select v-model="build_type">
            <option value="住宅">住宅</option>
            <option value="商住">商住</option>
            <option value="商铺">商铺</option>
            <option value="写字楼">写字楼</option>
          </select>
          </div>
          <div>
            <div class="grey">朝向</div>
            <select v-model="toward">
            <option value="东">东</option>
            <option value="南">南</option>
            <option value="西">西</option>
            <option value="北">北</option>
            <option value="南北">南北</option>
            <option value="东西">东西</option>
          </select>
          </div>
          <div>
            <div class="grey">年代</div>
            <input type="text" class="input_100" v-model="year">
          </div>
        </div>
        <div class="oneLine">
            <div>面积</div>
          <input type="text" class="input_100 mgLeft border" v-model="square">
          <div class="pf">m²</div>
            <div class="mgLeft">售价</div>
          <input type="text" class="input_150 mgX border" v-model="price" @input="toDanJia">
          <div>万元</div>
          <input type="text" class="input_150 mgX" v-model="price_dan" @input="toZongJia">
          <div>元/<span class="pf">m²</span></div>
          <div class="mgX">户型</div>
          <input type="text" class="input_60 border" v-model="room_count_shi">
          <div class="mgX">室</div>
          <input type="text" class="input_60" v-model="room_count_ting">
          <div class="mgX">厅</div>
          <input type="text" class="input_60" v-model="room_count_wei">
          <div class="mgX">卫</div>
          <input type="text" class="input_60" v-model="room_count_yang">
          <div  class="mgLeft">阳台</div>
        </div>
        <div class="oneLine">
            <div>来源</div>
          <input type="text" class="input_200 mgX border" v-model="from">
          <div>装修</div>
          <select class="mgLeft" v-model="decorate">
            <option value="毛坯">毛坯</option>
            <option value="清水">清水</option>
            <option value="简装">简装</option>
            <option value="精装">精装</option>
            <option value="豪装">豪装</option>
          </select>
          <select v-model="decorate_year">
            <option value="2019">2019</option>
            <option value="2018">2018</option>
            <option value="2017">2017</option>
            <option value="2016">2016</option>
            <option value="2015">2015</option>
            <option value="2014">2014</option>
            <option value="2013">2013</option>
            <option value="2012">2012</option>
            <option value="2011">2011</option>
            <option value="2010">2010</option>
            <option value="2009">2009</option>
            <option value="2008">2008</option>
            <option value="2007">2007</option>
            <option value="2006">2006</option>
          </select>
          <div class="mgX">现状</div>
          <select v-model="who_live">
            <option value="业主住">业主住</option>
            <option value="租客住">租客住</option>
            <option value="空置">空置</option>
          </select>
          <div class="mgX">动机</div>
          <input type="text" class="input_400 mgX" v-model="motive">
          <div>房东现状</div>
          <select class="mgX" v-model="stay">
            <option value="本地">本地</option>
            <option value="外地">外地</option>
            <option value="国外">国外</option>
          </select>
        </div>
      </div>
      <div class="part2">
        <div class="control">
          <div :class="{'active': current_column === '维护', 'common': true}" @click="current_column = '维护'">维护</div>
          <div :class="{'active': current_column === '图片', 'mgLeft': true, 'common': true}" @click="current_column = '图片'">图片</div>
        </div>
        <div class="notes" v-show="current_column === '维护'">
          <div v-if="noteList.length > 0">
            <div class="note" v-for="oneNote in noteList" :key="oneNote.id">
              <div class="words">
                {{oneNote.words}}
              </div>
              <div class="userAndTime">
                {{oneNote.user + '  ' + oneNote.create_time}}
              </div>
            </div>
          </div>
          <div v-else>
            暂无维护记录
          </div>
        </div>
        <div class="images" v-show="current_column === '图片'">
          <div v-if="images.length > 0">
            <div class="image" v-for="(img, index) in images" :key="index">
              <select v-model="img.name">
                <option value="主卧">主卧</option>
                <option value="主卧">次卧</option>
                <option value="主卧">书房</option>
                <option value="主卧">客厅</option>
                <option value="主卧">餐厅</option>
                <option value="主卧">厨房</option>
                <option value="主卧">主卫</option>
                <option value="主卧">客卫</option>
                <option value="主卧">阳台</option>
              </select>
              <img :src="img.src" preview="5" :preview-text="img.name">
            </div>
          </div>
          <div v-else>
            暂无图片
          </div>
        </div>
      </div>
      <div class="part3">
        <div class="left">
          <button @click="showPrompt = true">业主</button>
          <button class="input-file">传图
            <input type="file" @change="onInputFiles" id="input_image" multiple="multiple">
          </button>
        </div>
        <div class="right">
          <button @click="save">保存</button>
          <button @click="close">关闭</button>
        </div>
      </div>

    </div>
    <div class="prompt" v-if="showPrompt">
      <div class="prompt-in">
        <div class="oneLine">
          <div>业主姓名</div>
          <input type="text" class="input_150 mgX border" v-model="name">
          <div>称谓</div>
          <select class="mgX" v-model="appellation">
            <option value="先生">先生</option>
            <option value="小姐">小姐</option>
            <option value="女士">女士</option>
          </select>
          <div>联系电话</div>
          <input type="text" class="input_200 mgX border" v-model="phone">
          <div>其它联系方式</div>
          <input type="text" class="input_200 mgX" v-model="other_way">
        </div>
        <textarea cols="80" rows="10" v-model="note"></textarea>
        <button @click="addOneNote">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['item'],
    data() {
      return {
        house_id: '',
        realNameList: [],
        matchList: [],
        real_estate_name: '',
        real_estate_id: '',
        floor: '',
        unit: '',
        room_num: '',
        square: '',
        room_count_shi: '',
        room_count_ting: '',
        room_count_wei: '',
        room_count_yang: '',
        build_type: '',
        toward: '',
        year: '',
        price: '',
        price_dan: '',
        decorate: '',
        decorate_year: '',
        who_live: '',
        motive: '',
        name: '',
        appellation: '',
        phone: '',
        other_way: '',
        from: '',
        build_num: '',
        stay: '',
        current_column: '维护',
        showPrompt: false,
        note: '',
        noteList: [],
        images: [],
        imgData: {
          accept: 'image/gif, image/jpeg, image/png, image/jpg',
        },
        imgBaseUrl: 'https://www.xaoji.com:3001',
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let that = this
        that.$axios.get('/api/queryOneHouse', {
          params: {
            house_id: that.item.id
          }
        }).then(function (res) {
          console.log('一条房源', res)
          let house = res.data.data;
          that.house_id = house.id
          that.real_estate_id = house.real_estate_id
          that.real_estate_name = house.realEstate.real_estate_name
          that.build_num = house.build_num
          that.unit = house.unit
          that.room_num = house.room_num
          that.floor = house.floor
          that.square = house.square
          that.build_type = house.build_type
          that.toward = house.toward
          that.year = house.year
          that.from = house.from
          that.price = house.price
          that.who_live = house.who_live
          that.motive = house.motive
          that.name = house.name
          that.appellation = house.appellation
          that.phone = house.phone
          that.other_way = house.other_way
          that.stay = house.stay
          if (house.decorate) {
            if (house.decorate.indexOf('-') > -1) {
              that.decorate = house.decorate.split('-')[0]
              that.decorate_year = house.decorate.split('-')[1]
            } else {
              that.decorate = house.decorate
            }
          }
          if (house.room_count) {
            let arr = house.room_count.split('-')
            that.room_count_shi = arr[0]
            that.room_count_ting = arr[1]
            that.room_count_wei = arr[2]
            that.room_count_yang = arr[3]
          }
          that.price_dan = (parseInt(house.price) * 10000 / Number(house.square)).toFixed(2)
          that.noteList = house.noteList
        }).catch(function (res) {
          console.log('获取一条房源失败', res)
        })
      },

      close() {
        this.$emit('childOper', {
          from: 'oneHouse',
          oper: 'close'
        })
      },
      save() {
        let that = this
        if (!that.real_estate_id || !that.build_num || !that.room_num ||
          !that.floor || !that.room_count_shi || !that.square ||
          !that.from || !that.price || !that.name || !that.phone ||
          !that.house_id) {
          console.log('没有填完整')
          return
        }
        let obj = {
          id: that.house_id,
          real_estate_id: that.real_estate_id,
          build_num: that.build_num,
          unit: that.unit,
          room_num: that.room_num,
          floor: that.floor,
          square: that.square,
          build_type: that.build_type,
          toward: that.toward,
          year: that.year,
          from: that.from,
          price: that.price,
          who_live: that.who_live,
          motive: that.motive,
          name: that.name,
          appellation: that.appellation,
          phone: that.phone,
          other_way: that.other_way,
          stay: that.stay
        }
        let room_count = that.room_count_shi
        if (that.room_count_ting) {
          room_count += ('-' + that.room_count_ting)
        } else {
          room_count += '-0'
        }
        if (that.room_count_wei) {
          room_count += ('-' + that.room_count_wei)
        } else {
          room_count += '-0'
        }
        if (that.room_count_yang) {
          room_count += ('-' + that.room_count_yang)
        } else {
          room_count += '-0'
        }
        obj.room_count = room_count
        if (that.decorate) {
          if (that.decorate_year) {
            obj.decorate = that.decorate + '-' + that.decorate_year
          } else {
            obj.decorate = that.decorate
          }
        } else {
          obj.decorate = ''
        }
        let param = {
          'db': 'HouseModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post('/api/updateData', param).then(function (res) {
          console.log('上传返回', res)
          that.$emit('childOper', {
            from: 'oneHouse',
            oper: 'refresh'
          })
          that.close()
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      toDanJia() {
        let that = this
        if (that.square) {
          that.price_dan = (parseInt(that.price) * 10000 /
            Number(that.square)).toFixed(2)
        }
      },
      toZongJia() {
        let that = this
        if (!that.price_dan) {
          that.price = ''
          return
        }
        that.price = (parseInt(that.price_dan) * Number(that.square) /
          10000).toFixed(2)
      },

      addOneNote(){
        let that = this
        let note = that.note.replace(/\s/g, '')
        if (!note) {
          alert('请填写维护内容')
          return;
        }
        let obj = {
          words: that.note,
          house_id: that.house_id,
          user: '小鸡'
        }
        let param = {
          'db': 'NoteModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post('/api/updateData', param).then(function (res) {
          console.log('上传返回', res)
          that.init()
          that.showPrompt = false
          that.note = ''
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

      onInputFiles(event){
        let files = Array.from(event.target.files)
        this.chooseImage(files, event.target.id)
      },
      //生成一个随机数
      randomNum(n) {
        let rnd = ''
        for (let i = 0; i < n; i++) {
          rnd += Math.floor(Math.random() * 10)
        }
        return rnd
      },
    }
  }

</script>

<style scoped>
  input {
    outline: none;
  }

  .grey {
    color: grey;
  }

  .mgLeft {
    margin-left: 3px;
  }

  .mgX {
    margin: 0 3px;
  }

  select {
    padding: 1px 3px;
    outline: none;
    background-color: white;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -khtml-border-radius: 0;
    -webkit-appearance: none;
  }



  .oneHouse {
    width: 750px;
    position: fixed;
    z-index: 5;
    box-shadow: 0px 0px 10px rgb(50, 50, 50);
    overflow: hidden;
    font-size: 15px;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-60%);
    background-color: white;
  }

  .header {
    background-color: skyblue;
    display: flex;
    padding: 8px;
    justify-content: space-between;
  }

  .title {
    font-weight: 500;
  }

  .closeIcon {
    width: 16px;
    height: 16px;
    background: url('../../static/images/close.png') 0 0 no-repeat;
  }

  .content {
    padding: 8px;
    line-height: 25px;
  }

  .part1 {
    position: relative;
  }

  .oneLine {
    display: flex;
    align-items: center;
  }

  .saleRent {
    color: white;
    background-color: orange;
    padding: 3px;
    border-radius: 4px;
  }

  .part2{
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid skyblue;
  }
  .control{
    display: flex;
    /* border-bottom: 1px solid black; */
    box-sizing: border-box;
  }
  .common{
    background-color: skyblue;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    padding: 0 5px;
    box-sizing: border-box;
  }
  .active{
    background-color: white;
    border-bottom: 1px solid transparent;
  }
  .notes{
    margin-top: 5px;
    height: 200px;
    border: 1px solid skyblue;
    overflow-y: auto;
    padding: 5px 10px;
    box-sizing: border-box;
  }
  .note{
    display: flex;
    padding: 5px 10px;
    border-bottom: 1px dashed #cccccc;
    justify-content: space-between;
  }
  .words{
    width: 70%;
  }
  .userAndTime{
    width: 20%;
  }
  .images{
    margin-top: 5px;
    height: 200px;
    border: 1px solid skyblue;
    padding: 5px 10px;
    box-sizing: border-box;
  }
  .image{
    display: flex;
    flex-direction: column;
    align-items: center;

  }
  .image img{
    width: 100px;
    height: 100px;
  }


  .part3 {
    margin-top: 10px;
    border-top: 1px solid skyblue;
    display: flex;
    justify-content: space-between;
  }

  .part3 button {
    padding: 3px 10px;
    margin: 10px 5px 5px 0;
    border-radius: 5px;
    background-color: skyblue;
    outline: none;
  }
  .prompt{
    position: absolute;
    z-index: 8;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .prompt-in{
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    padding-top: 15px;
    width: 80%;
    margin: 50px auto;
  }
  textarea{
    resize: none;
    margin-top: 20px;
    outline: none;
  }
  .prompt-in button {
    padding: 3px 10px;
    margin: 10px 5px 5px 0;
    border-radius: 5px;
    background-color: skyblue;
    outline: none;
  }


  .pf{
      font-size: 10px;
  }


  .input_60 {
    width: 30px;
    height: 15px;
  }
  .input_100 {
    width: 50px;
    height: 15px;
  }

  .input_150 {
    width: 75px;
    height: 15px;
  }

  .input_200 {
    width: 100px;
    height: 15px;
  }

  .input_400 {
    width: 200px;
    height: 15px;
  }

  .border {
    border: 1px solid orange;
    height: 17px;
  }


  .input-file {
    overflow: hidden;
    position: relative;

  }

  #input_image {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 200px;
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/OneHouse.vue